/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from 'react'
import { useTransition } from 'react-spring'
import NotePreview from './NotePreview.js'
import NoteInputBox from '../../components/NoteInputBox'
import NoteTitleBox from '../../components/NoteTitleBox'
import NoteEditBox from '../../components/NoteEditBox'
import * as firebase from '../../helpers/firebase'
import './Notes.scss'
/* Creates a card preview for each stored note 
Uses refs to pass Note data to the Note Edit Box
Toggles an editor when a note is selected or deselected 
Select notes for deletion by switching on deleteMode
*/

let deleteList = []

const Notes = (props) => {
    const [notes, setNotes] = useState([])
    const fadeInTransitions = useTransition(notes, notes => notes.id, {
        from:  { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 }
    })
    const db = firebase.getDb()
    const user = props.user

    const [editorIsShown, setEditorIsShown] = useState(false)
    const [selectedNote, setSelectedNote] = useState(null)
    const [deleteMode, setDeleteMode] = useState(false)
    const [isDeleteReady, setDeleteReady] = useState(false)
    const [noteColor,setNoteColor] = useState('cornsilk')

    /* Manage Delete Button Style */
    let [deleteBtnStyle, setDeleteBtnStyle] = useState('trash-img-holder')
    
    const refCardHolder = useRef(null)
    const refInputBox = useRef(null)
    const refNewTitleBox = useRef(null)
    const refNotePreview = useRef(null)

/* If delete mode is active, add note IDs to delete list.
If deleteMode is not active:
Retrieve note info from selected note Preview.
Pass note info as props to Editor
Toggle the NoteEditBox display
Dim the background while NoteEditBox is in focus
/**** To Do: Replace "selectedNoteText" with "selectedNote"****/

    /* Handle preview card clicks */
    function handleCard(note){
        if(!deleteMode){
            setCurrentNote(note)
        }
    }
    const setCurrentNote = (note) =>{
        setSelectedNote(note)
        toggleEditorDisplay()
    }
    function toggleEditorDisplay(){
        if (editorIsShown){
            setEditorIsShown(false)
        }else if(!editorIsShown){
            setEditorIsShown(true)
        }
    }
    /* Add or remove selected item to delete list. 
    Display delete ready image when list is not empty
    */
    function checkDeleteList(id){
        if (deleteList.includes(id)){
            for (let x = 0; x < deleteList.length; x++){
                if (deleteList[x] === id){
                    deleteList.splice(deleteList[x],1)
                }
            }
            if(deleteList.length === 0){
                setDeleteBtnStyle('trash-img-holder-active')
            }else{
                setDeleteBtnStyle('trash-img-holder-ready')
            }
            return true
        }else{
            setDeleteBtnStyle('trash-img-holder-ready')
            deleteList.push(id)
            return false
        }
    }

    /* If delteMode is active:
    Complete deletion, then turn delete mode off and clear deleteList
    If deleteMode is inactive, turn it on
    */
    const handleDeleteClick = () => {
        if(deleteMode){ /* Switch delete mode off */
            completeDelete(deleteList)
            setDeleteMode(false)
            setDeleteReady(false)
            setDeleteBtnStyle('trash-img-holder')
            deleteList = []
        }
        else{ /* Switch delete mode on */
            setDeleteMode(true)
            setDeleteBtnStyle('trash-img-holder-active')
            setDeleteReady(true)
        }
    }
    /* Use deleteList to delete each note selected */
    const completeDelete = (deleteList) => {
        for (let x = 0; x < deleteList.length; x++){
            deleteNote(deleteList[x])
        }
    }

    async function deleteNote(id) {
        // e.stopPropagation()

        const db = firebase.getDb()

        return db.collection(`/users/${user.uid}/notes`)
                .doc(id)
                .delete()
                .then(function() {
                    console.log("note deleted successfully")
                }).catch(function(error){
                    console.log(error)
                })
                
    }

/**** To Do: refNewTitleBox.current.value Returns Null? ****/
    const getTitle = ()=> {
        const title = refNewTitleBox.current.value
        if(title.length > 0){
            console.log(title)
            return title
        }else if (title.length === 0){
            console.log(title)
            return "untitled"
        }
    }
    function getNoteColor(){
        return noteColor
    }
    // function setColor(color){
    //     setNoteColor(color)
    // }
    
    function clearTitle(){
        refNewTitleBox.current.value = ''
    }

    // function setCardColor(color){
    //     refNotePreview.current.style.backgroundColor = color
    // }

    // Responsive

    window.addEventListener('resize',handleResize())
    function handleResize(){
        
    }
    useEffect(() => {
        return db
                .collection(`/users/${user.uid}/notes`)
                .orderBy('createdDatetime', 'desc')
                .onSnapshot({ includeMetadataChanges: true }, querySnapshot => {
                    const loadedNotes = []

                    querySnapshot.forEach(doc => {
                        loadedNotes.push({ 
                            id: doc.id, 
                            isSaved: !doc.metadata.hasPendingWrites, 
                            data: { 
                                ...doc.data() 
                            } 
                        })
                    })

                    setNotes(loadedNotes)
                    console.log('Data came from', querySnapshot.metadata.fromCache ? 'local cache' : 'server')
                },
                error => console.log(error))
    }, [db, user.uid])   
    
    

    // TODO: a way to signify if notes havent fully saved to DB yet. We can key off
    // the note.isSaved field to display an icon in the header or somewhere.
    // Material Icons have some nice cloud icons that could be used: https://material.io/tools/icons/?search=cloud&style=outline
    return (
        <div className="App" id="container-app">
            {editorIsShown
                ?<NoteEditBox
                    toggleDisplay={toggleEditorDisplay}
                    user={user}
                    note={selectedNote}
                />
                :<div></div>}

            <header className="bg-app">
        
                {/* Title */}
                <div className="container-fluid d-flex mb-5" id="title">
                    <div className="row w-100">
                        <h1 className='col-6 mt-4 ml-5'><span className='g'>G</span>ecko Notes</h1>
                        <div className="col-3 mt-2 align-self-center ml-auto">
                            <button className="btn-main" onClick={() => firebase.signOut()}>Sign Out</button>
                        </div>
                        <div className="col-3 align-self-center">
                        </div>
                    </div>
                </div>
                
                <NoteTitleBox user={user} refNewTitleBox={refNewTitleBox}/>
                <NoteInputBox user={user} refInputBox={refInputBox} getTitle={getTitle} getNoteColor={getNoteColor} refNewTitleBox={refNewTitleBox} clearTitle={clearTitle}/>  
                        
                                
                {/* Notes Preview */}
                <div id="notes-preview" className='mt-5'>
                    <div className="container">
                        <div className="row" ref={refCardHolder}>
                        {/* Render the list of note previews into the body */}
                        { fadeInTransitions.map(({ item: note, key, props }) => (
                            // <animated.div className="col-lg-4 col-md-6 col-sm-6 col-xs-12" key={key} style={props}>
                            //     <div className="card mb-3">
                            //         <div className="card-body note-preview" ref={refNotePreview} accessKey={key} onClick={function(){handleCard(note,key);}}>
                            //             <h5 className="card-title">{note.data.title}</h5>
                            //             <p className="card-note-text">{note.data.text}</p>
                            //         </div>
                            //     </div>
                            // </animated.div>  
                            // <NotePreview note={note} id={note.id} index={key} style={props} deleteMode={deleteMode}></NotePreview>
                            <NotePreview key={key} checkDeleteList={checkDeleteList} onClick={handleCard} note={note} id={note.id} index={key} style={props} deleteMode={deleteMode}></NotePreview>

                            
                            // {/* <NotePreview ref={refNotePreview} note={note} key={key} accessKey={key} onClick={function(){handleCard(note,key);}}></NotePreview> */}
                            // <NotePreview ref={refNotePreview} note={note} key={key} onClick={handleCard}></NotePreview>
                            
                        ))}
                        </div>
                    </div>    
                </div>
                {/* Bulk Delete Button */}
                <div className={deleteMode?'trash-container-selected':'trash-container'} onClick={handleDeleteClick}>
                    <div className={deleteBtnStyle}>
                        <img className='trash-img' src='/images/trash.png'></img>
                    </div>  
                    {isDeleteReady
                        ?<div className='delete-text'>Delete</div>
                        :<div></div>
                    }
                </div>
                
            </header>
        </div>
    )
}


export default Notes